import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GeneralInformation } from '../models/system-configuration-model';
import { UrlBuilderService } from '../../common/services/url-builder.service';

@Injectable()
export class SystemConfigurationHttpService {

  constructor(private http: HttpClient,
    private urlBuilderService: UrlBuilderService) { }

  getSystemConfiguration(product: string): Observable<GeneralInformation> {
    const url = this.urlBuilderService.getIdentityServerUrl(`generalinformation/${product}`);
    return this
      .http
      .get<GeneralInformation>(url);
  }

  updateSystemConfiguration(product, model: GeneralInformation): Observable<string> {
    const configUrl = this.urlBuilderService.getIdentityServerUrl(`generalinformation/${product}`);
    const result = this
      .http
      .post(configUrl, model, { responseType: 'text' });

    return result;
  }

}
